<template>
    <div class="overlay" v-if="disclaimerVisible">
        <div class="window window-disclaimer border-primary">
            <div class="window-heading bg-primary">
                <button type="button" class="btn btn-close" @click="hideWindow">&times;</button>
                Disclaimers
            </div>
            <div class="window-body">
                <b>Warning: </b> This software is in development. Some feature
                may be missing or incomplete.

                <hr style="margin: .5rem 0;">

                The data reported here have been supplied by the United Network
                for Organ Sharing as the contractor for the Organ Procurement
                and Transplantation Network. The interpretation and reporting of
                these data are the responsibility of the author(s) and in no way
                should be seen as an official policy of or interpretation by the
                OPTN or the U.S. Government.
            </div>
            <div class="window-buttons">
                <button type="button" class="btn" @click="hideWindow">Ok</button>
            </div>
        </div>
    </div>
</template>

<script>
export default {
  name: 'DisclaimerWindow',

  computed: {
    disclaimerVisible: function () {
      return this.$store.getters.disclaimerVisible
    }
  },

  created () {
    // This is a little bit tricky because localStorage stores values
    // as string, so we need to hangle string/boolean type comparisons
    let shouldBeVisible = 'true'
    if (localStorage.disclaimerVisible !== undefined) {
      shouldBeVisible = localStorage.disclaimerVisible
    }
    if (this.disclaimerVisible !== shouldBeVisible) {
      this.$store.commit('setDisclaimerVisible', shouldBeVisible === 'true')
    }
  },

  methods: {
    hideWindow: function () {
      this.$store.commit('setDisclaimerVisible', false)
    }
  }
}
</script>

<style scoped>
.btn-close {
    float: right;
    border: none;
    padding: 0 .3rem;
    border-color: transparent;
}
.btn-close:hover {
    border: 1px solid #fff;
}
.overlay {
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    background-color: rgba(0, 0, 0, .5);
    z-index: 9000;
}
.window-disclaimer {
    position: fixed;
    top: 50%;
    left: 50%;
    width: 500px;
    transform: translate(-50%, -50%);
    max-width: 100%;
    background-color: #fff;
}
.window-body,
.window-heading,
.window-buttons {
    padding: 1rem;
}
.window-buttons {
    text-align: right;
}
</style>



// WEBPACK FOOTER //
// src/components/Dialogs/DisclaimerWindow.vue